import React from 'react'

const ViewArchive = () => {
  return (
    <div className='view-archive'>
      <a href='https://juanfalibene.com/writing/#/archive' className='view-archive-button' rel="noreferrer nofollow noopener">
        View Archive
      </a>
    </div>
  )
}

export default ViewArchive